<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard w-100 d-block"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-row>
            <b-col md="6">
              <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
            </b-col>
            <b-col md="6">
              <b-navbar-nav class="pull-right mr-auto">
                <b-nav-form>
                  <!-- v-if="($sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh') || ($sessionsStorage.get('designation') == 'HOD' && $sessionsStorage.get('nameUser') == 'Laxmi')" -->
                  <b-button
                    v-if="$route.path == '/viewBillingDetails/viewBillingDetails'"
                    :disabled="true"
                    style="font-size: 0.675rem ;margin-left: 5px;margin-bottom:4px;"
                    size="sm"
                    variant="warning"
                    id="addButtonLoaderpro"
                    @click="proceedToManualInv"
                    >New Billing</b-button
                  >
                  <Filter-Agency-Modal v-if="$sessionsStorage.get('is_Mobile') != 'port'" />
                  <FilterCBModal v-if="$sessionsStorage.get('is_Mobile') != 'port'" />
                  <ClientCard />
                  <ShipmentTrackCard />
                  <b-button
                    @click="goRolloverCont"
                    size="sm"
                    variant="success"
                    style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
                    >Rollover Container</b-button
                  >
                  
                  <b-button
                    v-if="
                      ($sessionsStorage.get('designation') == 'Admin' ||
                        BillingShowList.length > 0) &&
                      isEconomicYear
                      &&
                      $route.path == '/viewBillingDetails/viewBillingDetails'
                    "
                    style="font-size: 0.675rem"
                    size="sm"
                    class="text-left"
                    :variant="'info'"
                    @click="ActiveAccordion(BillingActiveStatus)"
                    >Show Billing Date</b-button
                  >
                   <ExcelExportButton
                        v-if="consoBooking.length > 0"
                        service-method="getAllBilllingJobDash"
                        :export-data="getExportPayload()"
                        :filename="'get-Billing-Job-panel-report.xlsx'"
                        button-text="Export As Excel"
                        exporting-text="Downloading Please Wait..."
                        size="sm"
                        variant="warning"
                        button-class="pull-right mb-1"
                        style="font-size: 0.675rem"
                        @export-success="onExportSuccess"
                        @export-error="onExportError"
                    />

                  <b-button
                    v-if="$route.path == '/viewBillingDetails/viewBillingDetails'"
                    style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
                    size="sm"
                    variant="outline-success"
                    @click="showInvoiceGraph = true"
                  >📊 Invoice Graph</b-button>
                </b-nav-form>
              </b-navbar-nav>
            </b-col>
          </b-row>
        </b-navbar>

        <b-card>
          <b-row
            v-if="
              ($sessionsStorage.get('designation') == 'Admin' ||
                BillingShowList.length > 0) &&
              isEconomicYear &&
              BillingActiveStatus
            "
          >
            <b-col md="2" class="mb-1">
              <label>Billing Start Date</label>
              <b-form-input
                :formatter="capitalizeAll"
                v-model="configration.config_bill_start_date"
                type="date"
                placeholder="Enter Billing Start Date"
                :min="calculateMinDate()"
                :max="calculateMaxDate()"
              ></b-form-input>
            </b-col>
            <b-col md="2" class="mb-1">
              <label>Billing End Date</label>
              <b-form-input
                :formatter="capitalizeAll"
                v-model="configration.config_bill_end_date"
                type="date"
                placeholder="Enter Billing End Date"
                :min="calculateMinDate()"
                :max="calculateMaxDate()"
              ></b-form-input>
            </b-col>
            <b-col md="2" class="mb-1">
              <label>Enter Billing Date</label>
              <b-form-input
                :formatter="capitalizeAll"
                v-model="configration.config_billing_date"
                type="date"
                placeholder="Enter Billing Date"
                :min="calculateMinDate()"
                :max="calculateMaxDate()"
              ></b-form-input>
            </b-col>
            <b-col md="4" v-if="$sessionsStorage.get('designation') == 'Admin'">
              <label>Allowed Users</label>
              <multi-select
                :options="$store.getters['common/getAllUserList']"
                :selected-options="user_items"
                v-model="configration.multiple_user_id"
                placeholder="Select User"
                :multiple="true"
                id="User"
                @select="SelectMultiUser"
              ></multi-select
            ></b-col>
            <b-col md="2" class="mb-1">
              <b-button
                class="ml-2 mb-2 mt-4"
                @click="updateConfig()"
                size="sm"
                variant="outline-info"
              >
                Save</b-button
              >
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" class="mb-1">
              <label>Date Filter Type</label>
              <model-list-select
                class="mb-1"
                :list="dateFilterTypeList"
                v-model="dateFilterType"
                option-value="value"
                option-text="text"
                placeholder="Select Date Type"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <label>Date Range</label>
              <date-range-picker
                :opens="openRight"
                :always-show-calendars="showCal"
                v-model="dateRange"
                :startDate="startDate"
                :endDate="endDate"
                :locale-data="locale"
              >
              </date-range-picker>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
                class="mb-1"
                :list="clientMaster"
                id="clientNamenew"
                v-model="clientIdFilter"
                option-value="clientId"
                option-text="clientName"
                placeholder="Select  Client Name"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <b-form-input
                :formatter="capitalizeAll"
                class="mb-1"
                v-model="InvoiceNoFilter"
                placeholder=" Invoice Number"
              ></b-form-input>
            </b-col>
            <b-col md="3" class="mb-1">
              <b-form-input
                :formatter="capitalizeAll"
                class="mb-1"
                v-model="vessleFilter"
                placeholder="Search Vessel"
              ></b-form-input>
            </b-col>
            <b-col md="3" class="mb-1">
              <b-form-input
                :formatter="capitalizeAll"
                class="mb-1"
                v-model="SBFilter"
                placeholder=" Shipping Bill Number"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mb-1">
              <model-list-select
                @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                :list="finalAllPlaceDataPOR"
                v-model="PORfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Place of Receipt"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
                @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                class="mb-1"
                :list="finalAllPlaceDataPOD"
                v-model="PODfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder="Select Port of Discharge"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
                :list="containerTypeList"
                v-model="containerTypeFilter"
                class="mb-1"
                option-value="containerTypeId"
                option-text="containerType"
                placeholder="Select Container Type"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
                :list="shippingLineList"
                v-model="shippingLineFilter"
                class="mb-1"
                option-value="shippingId"
                option-text="shippingLine"
                placeholder="Select Shipping Line"
              ></model-list-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mb-1">
              <b-form-input
                :formatter="capitalizeAll"
                v-model="ContainerFilter"
                placeholder=" Container  No."
              ></b-form-input>
            </b-col>
            <b-col md="3" class="mb-1">
              <b-form-input
                :formatter="capitalizeAll"
                class="mb-1"
                v-model="shiperInvFilter"
                placeholder=" Shipper Inv No."
              ></b-form-input>
            </b-col>
            <b-col md="3" class="mb-1">
              <b-form-input
                :formatter="capitalizeAll"
                class="mb-1"
                v-model="assignmentFilter"
                placeholder=" Assignment No."
              ></b-form-input>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
                class="mb-1"
                :list="jobList"
                v-model="jobTypeFilter"
                option-value="jv"
                option-text="jt"
                placeholder=" JobType"
              ></model-list-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="mb-1">
              <model-list-select
                :list="branchList"
                v-model="branchfilter"
                option-value="pickupId"
                option-text="pickupLocation"
                placeholder=" Branch"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
              :isDisabled="$route.path === '/viewBillingDetails/viewBillingDetails'?false:true"
                class="mb-1"
                :list="invoiceStatusList"
                v-model="statusFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Status"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
                class="mb-1"
                :list="SOBStatusList"
                v-model="SOBFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select SOB Status"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
                class="mb-1"
                :list="BillingStatusList"
                v-model="BillingFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Billing Status"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
                class="mb-1"
                :list="BillingTypeStatusList"
                v-model="BillingTypeFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Billing Type Status"
              ></model-list-select>
            </b-col>
            <b-col md="3" class="mb-1">
              <model-list-select
                class="mb-1"
                :list="SlinePaymentStatusList"
                v-model="SlinePaymentFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Payment Status"
              ></model-list-select>
            </b-col>

            <b-col md="3" class="mb-1">
              <b-form-input
                :formatter="capitalizeAll"
                class="mb-1"
                v-model="cnDNNoFilter"
                placeholder=" Overseas Number"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group class="mt-3">
                <b-form-checkbox-group
                  id="checkbox-group-1"
                  v-model="jobRecFilter"
                  :options="jobRecList"
                  name="flavour-1"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
        
            <b-col md="12" v-if="AllResubmissionJOBNO && $route.path == '/viewBillingDetails/viewBillingDetails'">
              <div class="marquee-container">
                <div class="marquee" ref="marquee">
                  <b-badge variant="danger" class="custom-badge"
                    ><b>{{ AllResubmissionJOBNO }}</b>
                  </b-badge>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12" center>
              <b-button
                size="sm"
                class="mb-2"
                @click="filterSearch"
                variant="outline-primary"
                >Search</b-button
              >

              <b-button
                size="sm"
                class="ml-2 mb-2"
                @click="clearFilter"
                variant="outline-info"
                >clear</b-button
              >
              <b-button
                class="ml-2 mb-2"
                :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
                @click="getReports('BILLING_SCREEN', 'Export As Excel')"
                size="sm"
                variant="outline-info"
              >
                {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export As Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <!-- <b-button
              size="sm"
              class="ml-2 mb-2"
              @click="getReports('BILLING_SCREEN')"
              variant="outline-info"
              >Export as Excel</b-button
            > -->

              <b-button
                class="ml-2 mb-2"
                :disabled="ExcelExecutionBtnName != 'Export All Execution' ? true : false"
                @click="getReports('BILLING_SCREEN_ALL', 'Export All Execution')"
                size="sm"
                variant="outline-info"
              >
                {{ ExcelExecutionBtnName }}
                <b-spinner
                  v-if="ExcelExecutionBtnName != 'Export All Execution'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <!-- <b-button
              size="sm"
              class="ml-2 mb-2"
              @click="getReports('BILLING_SCREEN_ALL')"
              variant="outline-info"
              > </b-button
            > -->
              <b-button
              v-if="$route.path == '/viewBillingDetails/viewBillingDetails'"
                class="ml-2 mb-2"
                :disabled="
                  ExcelMultiBillBtnName != 'Export All Multi Bill' ? true : false
                "
                @click="getReports('MultiBILLING_SCREEN', 'Export All Multi Bill')"
                size="sm"
                variant="outline-info"
              >
                {{ ExcelMultiBillBtnName }}
                <b-spinner
                  v-if="ExcelMultiBillBtnName != 'Export All Multi Bill'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>

              <b-button
              v-if="$route.path == '/viewBillingDetails/viewBillingDetails'"
                class="ml-3"
                :disabled="ExcelBSJBtnName != 'FF EXP OF REPORT' ? true : false"
                @click="getBuyingSellingJobsList('Excell')"
                size="sm"
                variant="outline-info"
              >
                {{ ExcelBSJBtnName }}
                <b-spinner
                  v-if="ExcelBSJBtnName != 'FF EXP OF REPORT'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <!-- <b-button
              size="sm"
              class="ml-2  mb-2"
              @click="getReports('MultiBILLING_SCREEN')"
              variant="outline-info"
              >Export All Multi Bill </b-button
            > -->
              <!-- <b-button
             v-if="($sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh')"
              size="sm"
              class="ml-3"
              @click="getReports('PENDING_REVERSE_BILLING')"
              variant="outline-info"
              >Export Pending Reverse Bill </b-button
            > -->
              <b-button
              v-if="$route.path == '/viewBillingDetails/viewBillingDetails'"
                size="sm"
                text="View Mult-Billing"
                class="ml-2 mb-2"
                variant="outline-info"
                @click="viewAllMultiBillingDetails()"
                >View All Mult-Billing</b-button
              >

              <!-- v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh' " -->
              <b-button
              v-if="$route.path == '/viewBillingDetails/viewBillingDetails'"
                size="sm"
                text="Lock & Un-Lock Panel"
                class="ml-2 mb-2"
                variant="outline-info"
                @click="viewAllUnlockDetails()"
                >Lock & Un-Lock Panel</b-button
              >
            </b-col>
          </b-row>
          <!-- <md-layout  md-flex="25" md-flex-small="100">
              <model-list-select
              class="mt-3"
                :list="SlinePaymentStatusList"
                v-model="SlinePaymentFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select SLine Payment Request"
              ></model-list-select>
            </md-layout> -->
          <!-- <b-form-select style="height: 50px; !important"  class="mt-3"  v-model="jobRecFilter"  :options="jobRecList" multiple :select-size="3"></b-form-select> -->
          <!-- <model-list-select
                              class="mt-3"
                            :list="jobRecList"
                          
                            option-value="jv"
                            option-text="jt"
                            placeholder="Job Received"
                          ></model-list-select> -->
        </b-card>

        <!-- Invoice Graph Modal -->
        <b-modal
          v-model="showInvoiceGraph"
          id="invoice-graph-modal"
          size="xl"
          title="📊 Billing Invoice Graph"
          hide-footer
          centered
        >
          <div v-if="!invoiceChartData" class="text-center p-4 text-muted">
            <h5>No data available. Please load records first.</h5>
          </div>
          <div v-else>
            <b-row>
              <b-col md="5">
                <apexchart
                  type="donut"
                  height="320"
                  :options="invoiceChartData.donut.chartOptions"
                  :series="invoiceChartData.donut.series"
                />
              </b-col>
              <b-col md="7">
                <apexchart
                  type="bar"
                  height="320"
                  :options="invoiceChartData.bar.chartOptions"
                  :series="invoiceChartData.bar.series"
                />
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="12" class="text-center text-muted">
                <small>Showing stats for <strong>{{ consoBooking.length }}</strong> records currently loaded on this page.</small>
              </b-col>
            </b-row>
          </div>
        </b-modal>

        <div class="box">
          <div>
            <b-pagination
              class="mt-3"
              limit="5"
              style="margin: 0px"
              align="center"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              @change="onPageChange($event)"
            ></b-pagination>
          </div>
          <div>
            <b-row class="align-content-end mt-3">
              <b-col cols="6" >
                <input
                    v-if="$route.path == '/viewBillingDetails/viewBillingDetails'"
                  type="checkbox"
                  @click="SelectAll(consoBooking)"
                  v-model="isCheckAll"
                />
                <label v-if="$route.path == '/viewBillingDetails/viewBillingDetails'">Select / Deselect All Count({{ this.AllModule_ids.length }})</label
                >
                <b-button
                  v-if="AllModule_ids.length > 0 && $route.path == '/viewBillingDetails/viewBillingDetails'"
                  size="sm"
                  @click="ProceedMultiBilling"
                  variant="outline-primary"
                  >Proceed Multi Billing</b-button
                >
              </b-col>
              <b-col cols="2">
                <h5 class="text-muted pull-right">
                  <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                </h5>
              </b-col>
              <b-col cols="4" style="padding: 0px 1rem 0 1rem">
                <model-list-select
                v-if="$route.path == '/viewBillingDetails/viewBillingDetails'"
                  :list="PaginationList"
                  v-model="PaginationCount"
                  option-value="pagv"
                  option-text="pagt"
                  placeholder="Select"
                  @input="pagechangeData()"
                ></model-list-select>

                <!-- @select="pagechangeData(PaginationCount)" -->
              </b-col>
            </b-row>
          </div>
          <!-- <h5 class="text-muted pull-right mt-2 ml-3">
            <small v-if="isLoading == false">{{ totalRows }} Entries</small>
          </h5> -->
          <!-- <md-layout md-gutter class="gutr">
            <md-layout md-flex="100">
              <b-form-input :formatter="capitalizeAll"
                v-model="filter"
                placeholder="Search Assignment"
                @input="viewFFExportFCL('0','1')"
              ></b-form-input>
            </md-layout>
          </md-layout>-->
          <div class="table-responsive tableMain mt-2">
            <b-table
              show-empty
              stacked="md"
              :items="consoBooking"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="jobType" slot-scope="row0">
                <input
                
                
                  v-if="row0.item.finalBillingCompleted != '1' && $route.path == '/viewBillingDetails/viewBillingDetails'"
                  type="checkbox"
                  v-bind:value="row0.item.allModuleId"
                  v-bind:id="row0.item.TPTClient"
                  v-model="AllModule_ids"
                  @change="updateSelectAll($event, row0.item)"
                />
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>

              <template slot="mainSalesSeries" slot-scope="row1">
                <b-badge variant="danger" v-if="row1.item.resubmissionInvStatus"
                  ><b>{{ row1.item.resubmissionInvStatus }}</b
                  ><br /></b-badge
                ><br />
                <md-icon>{{
                  row1.item.shipmentType == "1" ||
                  row1.item.shipmentType == "Sea_Shipment"
                    ? "directions_boat"
                    : "flight_takeoff"
                }}</md-icon>
                <b>{{ row1.item.mainSalesSeries }}</b
                ><br />
                <b v-if="row1.item.CNDNSeries">{{ "CN/DN : " + row1.item.CNDNSeries }}</b>
                <br />
                <span>
                  {{ row1.item.jobType }} ({{
                    row1.item.shipmentType == "1" ||
                    row1.item.shipmentType == "Sea_Shipment"
                      ? "Sea"
                      : "Air"
                  }}
                  {{ row1.item.transportType }})</span
                >
                <br />

                <span>Assignment Dt. : {{ row1.item.assignmentDate | moment }}</span>
                <br />
                <span>Raised From : {{ row1.item.raisedFrom }}<br /></span>
                <span> By : {{ row1.item.raisedBy }}</span> <br />
                <span
                  v-if="
                    row1.item.sob_date_detected != '' &&
                    row1.item.sob_date_detected != null
                  "
                  ><b :style="'color:black'">SOB : {{ row1.item.sob_date_detected }}</b>
                  <b-badge variant="danger"><b>SAILED</b></b-badge></span
                >
                <br />
                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row1.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
                <b-button
                  class="mt-1"
                  style="font-size: 0.675rem"
                  size="sm"
                  variant="outline-primary"
                  @click="$router.push({ path: '/billInvDash', query: { assignment: row1.item.mainSalesSeries } })"
                  >Inv Dashboard</b-button
                >
                <br />
                <Assignment-Summary
                  :title="'Shipment Summary Tracking - '"
                  :fk_all_module_id="row1.item.allModuleId"
                  :jb_series="row1.item.mainSalesSeries"
                />
                <Splitmerge-Summary
                  :SM_Status="1"
                  :title="'Split & Merge Track - '"
                  :SM_all_module_id="row1.item.allModuleId"
                  :SM_jb_series="row1.item.mainSalesSeries"
                  class="mt-2"
                  v-if="row1.item.SplitedStatus != '0'"
                />
                <!-- {{row1.item.SplitedStatus}} -->
                <Quotation-Summary
                  :QT_fk_all_module_id="row1.item.allModuleId"
                  :QT_jb_series="row1.item.mainSalesSeries"
                />
                <InvExpSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Inv Exp Summary Job No - ' + row1.item.mainSalesSeries"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <ContainerSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="'Container Summary Job No - ' + row1.item.mainSalesSeries"
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <RejectInvTallyBillSummary
                  v-if="row1.item.allModuleId"
                  :PMC_title="
                    'Invoice Rejection Log Summary Job No - ' + row1.item.mainSalesSeries
                  "
                  :PMC_JOBID="row1.item.allModuleId"
                  :PMC_JOBNO="row1.item.mainSalesSeries"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.mainSalesSeries"
                  />
                <!-- <ChangeLocation
                  v-if="row1.item.allModuleId"
                  :title="'Change Location Of Job No - ' + row1.item.mainSalesSeries"
                  :JOBID="row1.item.allModuleId"
                  :JOBNO="row1.item.mainSalesSeries"
                  :JOBDATE="''"
                  :JOBTYPE="''"
                /> -->
                <span>Lats Updated Dt. : {{ row1.item.latestUpdateForBilling }}</span>
              </template>
              <template slot="TPTClient" slot-scope="row11">
                <b
                  v-if="
                    row11.item.clientType == '3' && row11.item.transportType == 'Export'
                  "
                >
                  Client Name : {{ row11.item.exporter }}
                  <br />
                </b>

                <b v-if="row11.item.clientType == '3'">
                  Overseas Agent : {{ row11.item.TPTClient }}
                  <br />
                </b>
                <b v-if="row11.item.clientType != '3'">
                  {{ row11.item.TPTClient }}
                  <br />
                </b>
              </template>
              <template slot="ffInvoiceClosed" slot-scope="row2">
                <span v-if="row2.item.jobType.split(',').includes('FF')"
                  >FF :-
                  {{ row2.item.ffInvoiceClosed == "1" ? "Received" : "Not-Received" }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('CC')"
                  >CC :-
                  {{ row2.item.ccInvoiceClosed == "1" ? "Received" : "Not-Received" }}<br
                /></span>
                <span v-if="row2.item.jobType.split(',').includes('TPT')"
                  >TPT :-
                  {{
                    row2.item.tptInvoiceClosed == "1" ? "Received" : "Not-Received"
                  }}</span
                >
              </template>
              <template slot="containerNo" slot-scope="row15">
                  <b-button style="font-size: 0.675rem;margin-left: 5px" @click="
                proceedAssignmentProforma(
                  row15.item.allModuleId,
                  row15.item.isConsolidation,
                  row15.item.mainSalesSeries
                )
                " size="sm" class="ml-1" variant="outline-info">Proceed To Proforma</b-button>
                <BookingTrack v-if="row15.item.newfreightContainers && row15.item.jobType.indexOf('FF')>=0" :containerArr="row15.item.newfreightContainers"
                :slineName="row15.item.shippingLine"
                :clientName="row15.item.TPTClient"
                :modal_title="`Container Movement Booking No: ${row15.item.validBookingNo} Job No - ${row15.item.mainSalesSeries} Client: ${row15.item.TPTClient}`"
                :JOBNO="row15.item.mainSalesSeries" :shipment_id="Number(0)" :subscription_id="Number(0)" :fk_sub_track_id="Number(0)"
                :fk_all_module_id="Number(row15.item.allModuleId)" :fk_booking_id="Number(row15.item.fk_booking_id)"
                :fk_container_id="Number(0)" :booking_number="row15.item.validBookingNo" :container_number="''" />
                <div v-if="row15.item.containerNo">
                  <span
                    v-for="(item1, index) in row15.item.containerNo.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item1 == "" ? "-------" : item1 }}
                      </b-badge>
                    </h6>
                    <ContaierWebLogSummary
                          v-if="row15.item.allModuleId && item1 && row15.item.jobType.split(',').includes('FF')"
                          :PMC_title="'Container Event Summary Job No - ' + row15.item.mainSalesSeries"
                          :PMC_JOBID="row15.item.allModuleId"
                          :PMC_JOBNO="row15.item.mainSalesSeries"
                          :PMC_CONTNO="item1.split(' // ')[0]"
                          :PMC_JOBDATE="''"
                          :PMC_JOBTYPE="''"
                          :PMC_AgentType="''"
                          :PMC_Client="''"
                          :PMC_Sline="''"
                        />
                    </span
                  >
                </div>
                <span v-else>-----------</span>
              </template>
              <template slot="shipperInv" slot-scope="row150">
                <div v-if="row150.item.shipperInv">
                  <span
                    v-for="(item2, index) in row150.item.shipperInv.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item2 == "" ? "-------" : item2 }}
                      </b-badge>
                    </h6></span
                  >
                </div>
                <span v-else>-----------</span>
              </template>
              <template slot="ShippingB" slot-scope="row100">
                <div v-if="row100.item.ShippingB">
                  <span
                    v-for="(item3, index) in row100.item.ShippingB.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6></span
                  >
                </div>
                <span v-else>-----------</span>
              </template>

              <template slot="billingSeries" slot-scope="row1000">
                <b-badge v-if="$route.path!='/viewBillingDetails/viewClosedAgentExpensePending'" :variant="row1000.item.is_expense_status == 'Yes' ? 'success' : 'danger'"><b>Expense : {{ row1000.item.is_expense_status }}</b><br/></b-badge>
                <b-badge v-else-if="$route.path=='/viewBillingDetails/viewClosedAgentExpensePending'" :variant="row1000.item.is_agent_expense_status == 'Yes' ? 'success' : 'danger'"><b>Expense : {{ row1000.item.is_agent_expense_status }}</b><br/></b-badge>
                <b-badge :variant="row1000.item.is_additionalTask_status == 'Yes' ? 'success' : 'danger'"><b>Additional Task : {{ row1000.item.is_additionalTask_status }}</b><br/></b-badge>
                <b-badge :variant="row1000.item.is_manifest_status == 'Yes' ? 'success' : 'danger'"><b>Manifestation : {{ row1000.item.is_manifest_status }}</b><br/></b-badge>

                <span
                  v-if="
                    row1000.item.jobType.split(',').includes('MISC') ||
                    row1000.item.jobType.split(',').includes('YARD') ||
                    row1000.item.jobType.split(',').includes('IB')
                  "
                >
                  <div v-if="row1000.item.billingSeries">
                    <span
                      v-for="(item3, index) in row1000.item.billingSeries.split(',')"
                      :key="index"
                      ><h6>
                        <b-badge variant="light"
                          >{{ item3 == "" ? "-------" : item3 }}
                        </b-badge>
                      </h6></span
                    >
                  </div>
                  <span v-else>-----------</span>
                </span>
                <span v-else>
                  <div
                    v-if="
                      (row1000.item.shipmentType == '1' ||
                        row1000.item.shipmentType == 'Sea_Shipment') &&
                      row1000.item.invoiceNoCreated
                    "
                  >
                    <span
                      v-for="(item3, index) in row1000.item.invoiceNoCreated.split(',')"
                      :key="index"
                      ><h6>
                        <b-badge variant="light"
                          >{{ item3 == "" ? "-------" : item3 }}
                        </b-badge>
                      </h6></span
                    >
                  </div>
                  <div
                    v-else-if="
                      (row1000.item.shipmentType != '1' ||
                        row1000.item.shipmentType != 'Sea_Shipment') &&
                      row1000.item.billingSeries
                    "
                  >
                    <span
                      v-for="(item3, index) in row1000.item.billingSeries.split(',')"
                      :key="index"
                      ><h6>
                        <b-badge variant="light"
                          >{{ item3 == "" ? "-------" : item3 }}
                        </b-badge>
                      </h6></span
                    >
                  </div>
                  <span v-else>-----------</span>
                </span>
              </template>
              <!-- <template slot="billingSeries" slot-scope="row1000">
                <div v-if="row1000.item.billingSeries">
                  <span
                    v-for="(item3, index) in row1000.item.billingSeries.split(',')"
                    :key="index"
                    ><h6>
                      <b-badge variant="light"
                        >{{ item3 == "" ? "-------" : item3 }}
                      </b-badge>
                    </h6></span
                  >
                </div>
                <span v-else>-----------</span>
              </template> -->
              <template slot="Payment_Status" slot-scope="row16">
                <b-badge
                  :variant="row16.item.oe_exp_payment_status == 'Yes' ? 'success' : 'danger'"
                  ><b>OE Exp Paid Status : {{ row16.item.oe_exp_payment_status }}</b><br/></b-badge
                >
                <b v-if="row16.item.oe_exp_payment_date">OE Exp Paid Date : {{ row16.item.oe_exp_payment_date }}</b><br/>
                <b-badge
                  :variant="row16.item.Payment_Status == 'Yes' ? 'success' : 'danger'"
                  ><b>{{ row16.item.Payment_Status }}</b></b-badge
                >
                <b-badge
                  :variant="
                    row16.item.billingType == 'Overseas Billing' ? 'success' : 'info'
                  "
                  ><b>{{ row16.item.billingType }}</b></b-badge
                >
              </template>
              <template slot="mainEnquiryId" slot-scope="row15">
                
                <!-- v-if="$route.path == '/viewBillingDetails/viewBillingDetails'" -->
                <b-button
                  @click="
                    proceedBilling(
                      row15.item.allModuleId,
                      row15.item.newContainerFlow,
                      row15.item.isConsolidation,
                      row15.item.mainSalesSeries
                    )
                  "
                  variant="primary"
                  size="sm"
                  >{{
                    (row15.item.finalBillingCompleted == "1" || row15.item.finalBillingCompleted == "4") ||
                    (row15.item.billingType == "Overseas Billing" &&
                      row15.item.closedOverseasStatus == "Overseas Closed")
                      ? "Show Billing"
                      : "Proceed To Billing"
                  }}</b-button
                ><br />

                <br />
                <!-- {{row15.item.CRDRArr}} -->
                <div v-for="(cr_item, cr_index) in row15.item.CRDRArr" :key="cr_index">
                  <!-- {{cr_item}} -->
                  <b-badge
                    v-if="
                      row15.item.frghtTermsMbl == 'Collect' &&
                      row15.item.frghtTermsHbl == 'Collect'
                    "
                    class="p-2"
                    variant="warning"
                    ><b>Credit Note Pending</b><br />
                  </b-badge>
                  <b-badge
                    class="p-1"
                    variant="warning"
                    v-if="
                      cr_item.uploadCreditDebit != '' && cr_item.approvalStatus == '1'
                    "
                    @click="
                      PrintNote(row15.item.mainSalesSeries, cr_item.uploadCreditDebit)
                    "
                    size="sm"
                    ><span v-if="cr_item.creditDebitNoteType == '1'"
                      >{{ cr_item.noteSeries }}
                    </span>
                    <b v-else>{{ cr_item.noteSeries }}</b
                    ><br
                  /></b-badge>
                  <b-badge
                    class="p-1"
                    variant="warning"
                    v-if="
                      row15.item.mainSalesSeries == 'FFCon/Exp/MOR/15715/2021-22' &&
                      cr_item.uploadCreditDebit != '' &&
                      cr_item.approvalStatus == '1' &&
                      cr_item.creditDebitNoteType == '2'
                    "
                    @click="
                      PrintNote(
                        row15.item.mainSalesSeries,
                        'Approved-DEBIT -2022-02-03 11:37:17.pdf'
                      )
                    "
                    size="sm"
                    ><span v-if="cr_item.creditDebitNoteType == '1'"
                      >{{ cr_item.noteSeries }}
                    </span>
                    <b v-else>{{ cr_item.noteSeries }}</b
                    ><br /></b-badge
                  ><br />
                  <b-badge
                    v-if="cr_item.creditDebitNoteType"
                    class="p-2"
                    variant="success"
                    ><b
                      >{{
                        cr_item.creditDebitNoteType == "1" ? "Credit" : "Debit"
                      }}
                      Generated on {{ cr_item.creditDebitTime }}</b
                    >
                  </b-badge>
                </div>

                <b-badge variant="warning" v-if="row15.item.isConsolidation == '1'"
                  >Consolidation</b-badge
                >

                <b-badge
                  variant="success"
                  v-if="
                    (row15.item.finalBillingCompleted == '1') ||
                    (row15.item.billingType == 'Overseas Billing' &&
                      row15.item.closedOverseasStatus == 'Overseas Closed')
                  "
                  >Billing Completed</b-badge
                >
                <b-badge v-else-if="row15.item.finalBillingCompleted == '4'" variant="success">Billing Completed - Agent Expense Pending</b-badge>
                <b-badge v-else variant="danger">Billing In-complete</b-badge>

                <br />
                <!-- {{row15.item.billingType}}
                {{row15.item.closedOverseasStatus}} -->
                
                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  v-if="
                    ((((row15.item.finalBillingCompleted != '1' || row15.item.finalBillingCompleted != '4' )&&
                      row15.item.billingType != 'Overseas Billing') ||
                    ((row15.item.finalBillingCompleted == '1' || row15.item.finalBillingCompleted == '4') &&
                      row15.item.billingType == 'Overseas Billing' &&
                      row15.item.closedOverseasStatus != 'Overseas Closed')) && row15.item.totalExpCount<=0 && row15.item.FF_Job_Exist_Flag==1 && row15.item.agent_handling_expense=='Yes' && row15.item.transportType=='Export' && row15.item.nature_of_expense!=='AGENT INVOICE') && $route.path !== '/viewBillingDetails/viewClosedAgentExpensePending'
                  "
                  size="sm"
                  @click="validateBilling(row15.item.allModuleId, row15.item.jobType)"
                  variant="outline-info"
                  >Closed. Agent Expense Pending </b-button
                >

                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  v-else="
                    (row15.item.finalBillingCompleted != '1' &&
                      row15.item.billingType != 'Overseas Billing') ||
                    (row15.item.finalBillingCompleted == '1' &&
                      row15.item.billingType == 'Overseas Billing' &&
                      row15.item.closedOverseasStatus != 'Overseas Closed')
                  "
                  size="sm"
                  @click="validateBilling(row15.item.allModuleId, row15.item.jobType)"
                  variant="outline-info"
                  >Close Billing</b-button
                >
            
                <b-button
                  v-if="!row15.item.fk_loss_job_user_id && $route.path == '/viewBillingDetails/viewBillingDetails'"
                  style="font-size: 0.675rem"
                  class="mt-2"
                  size="sm"
                  @click="validateKnownLossJobModal(row15.item.allModuleId, row15.item.jobType,row15.item)"
                  variant="outline-info"
                  >Known Loss Job</b-button>
                  <span v-if="row15.item.fk_loss_job_user_id">Loss Job Remark:{{ row15.item.known_loss_job_remark }}<br/>User Name:{{ row15.item.loss_job_user }}<br/>Loss Job Date:{{ row15.item.known_loss_job_date }}<br/></span>
                <!-- {{row15.item.isMultiBilling+"Test"}} -->
                <!-- <b-button 
                  style="font-size: 0.675rem"
                  v-if="row15.item.isMultiBilling==1" 
                  size="sm" 
                  text="View Mult-Billing" 
                  class="m-2"
                  variant="outline-info"
                  @click="viewMultiBillingDetails(row15.item.allModuleId,row15.item.multibillingSeries,row15.item)"
                >View Mult-Billing</b-button> -->
                <span
                  style="color: green"
                  v-if="row15.item.assignmentCloseReason"
                  v-html="wordWrap(row15.item.assignmentCloseReason, 12)"
                ></span>
                <Add-Message
                  :fk_all_module_id="row15.item.allModuleId"
                  style="list-style-type: none"
                />

                <!-- closeBill(row15.item.allModuleId) -->

                <!-- <b-form-checkbox v-if="row15.item.billingSeries" @change="row15.toggleDetails" v-model="row15.detailsShowing"></b-form-checkbox>
              <span class="error" v-if="row15.item.billingSeries"  >Show Added Invoice</span> -->
              </template>

              <!-- <template slot="show_details" slot-scope="row7">
                <b-form-checkbox
                  @change="row7.toggleDetails"
                  v-model="row7.detailsShowing"
                ></b-form-checkbox>
              </template> -->
              <!-- <template slot="row-details" slot-scope="row7">
                <b-card style="background: whiteSmoke">
                  <div v-if="row7.item.shipmentType == '1'">
                    <span
                      >Container Type :
                      {{ row7.item.multipleContainerType }}</span
                    >
                    <br />
                    <span>No of Containers : {{ row7.item.multiConNo }}</span>
                    <br />
                    <span>Shipping Line : {{ row7.item.shippingLine }}</span>
                    <br />
                    <span>Pickup : {{ row7.item.pickup }}</span>
                    <br />
                    <span>Stuffing : {{ row7.item.stuffingLoc }}</span>
                    <br />
                    <span>Handover : {{ row7.item.handover }}</span>
                    <br />
                    <span>Place of Receipt : {{ row7.item.POR }}</span>
                    <br />
                    <span>Load Port : {{ row7.item.LP }}</span>
                    <br />
                    <span>Port of Discharge : {{ row7.item.POD }}</span>
                    <br />
                    <span
                      >Final Place of Delivery :
                      {{ row7.item.finalPlace }}</span
                    >
                  </div>
                  <div v-else>
                    <span>
                      Departure Airport : {{ row7.item.AirDept }}
                      <br />
                    </span>
                    <span>
                      Destination Airport : {{ row7.item.airDesti }}
                      <br />
                    </span>
                    <span>
                      No.of Packages : {{ row7.item.noOfPkg }}
                      <br />
                    </span>
                    <span>
                      Cargo Received At :
                      {{
                        row7.item.cargoReceived == "1" ? "Airport" : "Warehouse"
                      }}
                      <br />
                    </span>
                  </div>
                </b-card>
              </template> -->
            </b-table>
          </div>
        </div>

        <div>
          <!-- <h5> -->
          <b-pagination
            limit="5"
            align="center"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            @change="onPageChange($event)"
          ></b-pagination>
          <!-- </h5> -->
        </div>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
      <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <b-modal
      id="modal-close-conf"
      ref="modal-close-conf"
      title="Submit Your Reason"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h3>Confirmation</h3>
      <h4 class="error" v-if="incompleteJobBill">
        <small>Invoice Not added for </small> {{ incompleteJobBill }}
        <small> Please Kindly Check..!</small>
      </h4>
      <form ref="form">
        <b-form-group
          label="Reason for closing assignment billing"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="closingReason"
            required
          ></b-form-textarea>
        </b-form-group>
      </form>
      <b-button
        :disabled="closingReason ? false : true"
        variant="success"
        @click="closeBillOk"
      >
        Confirm & Close Billing</b-button
      >
      <b-button @click="closeModalConfirm" variant="danger" class="pull-right">
        Cancel</b-button
      >
    </b-modal>
    <b-modal ref="KnownLossJobModal" no-close-on-esc no-close-on-backdrop title="Known Loss Job Request" size="xs" hide-footer
        @hidden="closeKnownLossJobModal">
        <!-- Modal content remains the same -->
        <b-row class="mb-2">
          <b-col cols="12">
            <label for="remark">Remark : *</label>
            <b-textarea rows="5" id="remark" placeholder="Pls Enter Remark"  type="text" v-model="knownLossJobItem.remark" />
        </b-col>
        </b-row>

        <b-row class="justify-content-end">
          <b-button :disabled="knownLossJobItem.remark?false:true" variant="primary" style="font-size: 0.675rem" @click="validateKnownLossJob">Send</b-button>
          <b-button variant="secondary" style="font-size: 0.675rem" @click="closeKnownLossJobModal" class="ml-2">Close</b-button>
        </b-row>
    </b-modal>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopApprove"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopReject"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseAction"
      ref="addPopDelete"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopTally"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopClose1"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeconsolidationTXTOk"
      ref="addPopClose"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import {
  globalPermissionStatus,
  lastVisitPage,
  GlobalGetLocation,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AddMessage from "../../component/allModuleForm/addMessage.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import SplitmergeSummary from "../../component/common/splitmergeSummary.vue";
import QuotationSummary from "../../component/common/quotationSummary.vue";
import CommonService from "../../services/CommonService.js";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import ChangeLocation from "../common/changeLocation.vue";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import CustomLoader from "../common/customLoader.vue";
import MasterService from "../../services/MasterService.js";
import BookingTrack from "../consoleBooking/bookingTrack.vue";
import ExcelExportButton from "../common/ExcelExportButton.vue";
import VueApexCharts from "vue-apexcharts";


export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.getConfig();
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/viewBillingDetails/viewBillingDetails");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      knownLossJobItem:{
        remark:'',
        allModuleId:'',
      },
      BillingShowList: [],
      configration: {
        config_id: "",
        config_billing_date: "",
        config_bill_start_date: "",
        config_bill_end_date: "",

        multiple_user_arr: [],
        multiple_user_id: "",
        userName: "",
      },
      BillingActiveStatus: false,
      user_items: [],
      economicYearStartMonth: 3, // March
      economicYearEndMonth: 4, // April
      //Added By Priyanshu Singh Multi Select Start
      isCheckAll: false,
      AllModule_ids: [],
      AllClient_ids: [],
      selectedAllModule_ids: "",
      selectedClient_ids: "",

      PORfilter: "",
      PODfilter: "",
      containerTypeFilter: "",
      shippingLineFilter: "",
      finalAllPlaceDataPOD: [],
      finalAllPlaceDataPOR: [],
      shippingLineList: [],
      containerTypeList: [],
      //Added By Priyanshu Singh Multi Select Start
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      dateFilterType: "assignment",
      dateFilterTypeList: [
        {
          value: "assignment",
          text: "Assignment Date",
        },
        {
          value: "billing",
          text: "Billing Date",
        },
      ],
      dateSearch: {
        fromDate: "",
        toDate: "",
      },
      closingReason: "",
      eventId: "",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openRight: "right",
      showCal: false,
      showDash: false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      branchList: [],
      totalRows: 1000000000000000,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "jobType",
          mainkey: "jobType",
          label: "#",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainSalesSeries",
          mainkey: "mainSalesSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "TPTClient",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "containerNo",
          mainkey: "containerNo",
          label: "Container // Container Type",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "shipperInv",
          mainkey: "shipperInv",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
        {
          key: "ShippingB",
          mainkey: "ShippingB",
          label: "Shipping Bill",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },

        {
          key: "ffInvoiceClosed",
          mainkey: "ffInvoiceClosed",
          label: "Execution Invoice",
          sortable: true,
          sortDirection: "ASC",
          table: "Z.",
        },
        {
          key: "billingSeries",
          mainkey: "billingSeries",
          label: "Inv No.Added to Tally ",
          sortable: true,
          sortDirection: "ASC",
          //  table: "B."
        },

        // {
        //   key: "tptInvoiceClosed",
        //   mainkey: "tptInvoiceClosed",
        //   label: "Invoice Status",
        //   sortable: true,
        //   sortDirection: "ASC"
        // },

        {
          key: "Payment_Status",
          mainkey: "Payment_Status",
          label: "Sline Payment Request",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "mainEnquiryId",
          mainkey: "mainEnquiryId",
          label: "Billing",
          sortable: true,
          sortDirection: "ASC",
        },
        // {
        //   key: "show_details",
        //   mainkey: "tptInvoiceClosed",
        //   label: "More Details",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
      ],
      // dateSearch: {
      //   fromDate: "",
      //   toDate: ""
      // },
      // eventId: "",
      mailallModuleId: "",
      mailExecSeries: "",
      incompleteJobBill: "",
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      clientIdFilter: "",
      assignmentFilter: "",
      ContainerFilter: "",
      shiperInvFilter: "",
      InvoiceNoFilter: "",
      vessleFilter:"",
      cnDNNoFilter: "",
      SBFilter: "",
      selectedAllModuleId: "",
      jobTypeFilter: "",
      statusFilter: this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0",
      branchfilter: "",
      jobRecFilter: [],
      consoBooking: [],
      clientMaster: [],
      AllResubmissionJOBNO: "",
      ExcelBtnName: "Export As Excel",
      ExcelExecutionBtnName: "Export All Execution",
      ExcelMultiBillBtnName: "Export All Multi Bill",
      reload: true,
      jobRecList: [
        { value: "0", text: "TPT Received" },
        { value: "1", text: "CC Received" },
        { value: "2", text: "FF Received" },
      ],
      PaginationList: [
        {
          pagv: "25",
          pagt: "25",
        },
        {
          pagv: "50",
          pagt: "50",
        },
        {
          pagv: "75",
          pagt: "75",
        },
        {
          pagv: "100",
          pagt: "100",
        },
        {
          pagv: "125",
          pagt: "125",
        },
        {
          pagv: "150",
          pagt: "150",
        },
        {
          pagv: "175",
          pagt: "175",
        },
        {
          pagv: "200",
          pagt: "200",
        },
        {
          pagv: "225",
          pagt: "225",
        },
        {
          pagv: "250",
          pagt: "250",
        },
        {
          pagv: "275",
          pagt: "275",
        },
        {
          pagv: "300",
          pagt: "300",
        },
        {
          pagv: "325",
          pagt: "325",
        },
        {
          pagv: "350",
          pagt: "350",
        },
        {
          pagv: "375",
          pagt: "375",
        },
        {
          pagv: "400",
          pagt: "400",
        },
      ],
      PaginationCount: "",
      jobList: [
        {
          jv: "FF",
          jt: "FF",
        },
        {
          jv: "CC",
          jt: "CC",
        },
        {
          jv: "TPT",
          jt: "TPT",
        },
      ],
      invoiceStatusList: [
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "2",
          int: "All",
        },
        {
          inv: "3",
          int: "No-Billing",
        },
        {
          inv: "4",
          int: "Billing Completed - Agent Expense Pending",
        },
      ],
      SOBFilter: "3",
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      BillingFilter: "3",
      BillingStatusList: [
        {
          inv: "1",
          int: "Normal Billing",
        },
        {
          inv: "2",
          int: "Multi Billing",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      BillingTypeFilter: "3",
      BillingTypeStatusList: [
        {
          inv: "1",
          int: "Local Billing",
        },
        {
          inv: "2",
          int: "Overseas Billing",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      SlinePaymentFilter: "All",
      SlinePaymentStatusList: [
        {
          inv: "Yes",
          int: "Yes",
        },
        {
          inv: "No",
          int: "No",
        },
        {
          inv: "All",
          int: "All",
        },
      ],
      ExcelBSJBtnName: "FF EXP OF REPORT",
      showInvoiceGraph: false,
    };
  },

  mounted() {
    // Only restart marquee if the element exists (when AllResubmissionJOBNO is available)
    this.$nextTick(() => {
      if (this.$refs.marquee) {
        this.restartMarquee();
      }
    });
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  created() {
    this.viewFFExportFCL("0", "1", "1");
    // EventBus.$on("file-selected", (file) => {
    //   this.selectedFile = file;
    // });
    // eventBus.$on("StatusCode", (StatusCode) => {
    //   if (StatusCode == 1) {
    //     // if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
    //     //   this.fetchLastPage(this.lastVisitPage);
    //     // } else {
    //       this.viewFFExportFCL("0", "1", "1");
    //     // }
    //   }
    // });
  },
  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    MultiSelect,
    DateRangePicker,
    DocForm,
    AddMessage,
    AssignmentSummary,
    QuotationSummary,
    SplitmergeSummary,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    ContaierWebLogSummary,
    RejectInvTallyBillSummary,
    ChangeLocation,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    CustomLoader,
    BookingTrack,
    ExcelExportButton,
    apexchart: VueApexCharts,
  },

  computed: {
    isEconomicYear() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      return (
        currentMonth <= this.economicYearStartMonth ||
        currentMonth <= this.economicYearEndMonth
      );
    },
    invoiceChartData() {
      const data = this.consoBooking;
      if (!data || data.length === 0) return null;

      // Billing Status Donut
      let billingPending = 0, billingComplete = 0, billingAgentExp = 0;
      // FF/CC/TPT Invoice Received bar
      let ffReceived = 0, ffPending = 0;
      let ccReceived = 0, ccPending = 0;
      let tptReceived = 0, tptPending = 0;

      data.forEach((item) => {
        const fc = String(item.finalBillingCompleted || '0');
        if (fc === '1') billingComplete++;
        else if (fc === '4') billingAgentExp++;
        else billingPending++;

        const jt = (item.jobType || '').split(',');
        if (jt.includes('FF')) {
          item.ffInvoiceClosed === '1' ? ffReceived++ : ffPending++;
        }
        if (jt.includes('CC')) {
          item.ccInvoiceClosed === '1' ? ccReceived++ : ccPending++;
        }
        if (jt.includes('TPT')) {
          item.tptInvoiceClosed === '1' ? tptReceived++ : tptPending++;
        }
      });

      return {
        donut: {
          series: [billingPending, billingComplete, billingAgentExp],
          chartOptions: {
            chart: { type: 'donut', height: 320 },
            labels: ['Billing Pending', 'Billing Complete', 'Agent Expense Pending'],
            colors: ['#FF4560', '#00E396', '#FEB019'],
            legend: { position: 'bottom' },
            plotOptions: { pie: { donut: { size: '65%' } } },
            dataLabels: { enabled: true },
            title: { text: 'Billing Status Breakdown', align: 'center', style: { fontSize: '14px' } },
          },
        },
        bar: {
          series: [
            { name: 'Received', data: [ffReceived, ccReceived, tptReceived] },
            { name: 'Not Received', data: [ffPending, ccPending, tptPending] },
          ],
          chartOptions: {
            chart: { type: 'bar', height: 320, stacked: false },
            xaxis: { categories: ['FF Invoice', 'CC Invoice', 'TPT Invoice'] },
            colors: ['#00E396', '#FF4560'],
            plotOptions: { bar: { horizontal: false, columnWidth: '50%', borderRadius: 4 } },
            legend: { position: 'top' },
            title: { text: 'Execution Invoice Received Status', align: 'center', style: { fontSize: '14px' } },
            dataLabels: { enabled: true },
          },
        },
      };
    },
  },
  watch: {
    clientIdFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter ||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ) {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
    shiperInvFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter ||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ) {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
    SBFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter ||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ) {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
    ContainerFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter ||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ) {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
    jobTypeFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter ||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ){
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
    branchfilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ){
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
    assignmentFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter ||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ){
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
    InvoiceNoFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter ||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ){
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
    vessleFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter ||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ){
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
    cnDNNoFilter: {
      handler: function (newVal, oldVal) {
        if (
          this.clientIdFilter ||
          this.shiperInvFilter ||
          this.InvoiceNoFilter ||
          this.vessleFilter ||
          this.cnDNNoFilter ||
          this.SBFilter ||
          this.ContainerFilter ||
          this.jobTypeFilter ||
          this.branchfilter ||
          this.jobRecFilter ||
          this.assignmentFilter ||
          this.PORfilter ||
          this.PODfilter ||
          this.containerTypeFilter ||
          this.shippingLineFilter
        ){
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"2";
        } else {
          this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
        }
      },
      deep: true,
    },
     // Watch for route changes
     $route: {
      immediate: true, // Call immediately when the component is loaded
      handler() {
        this.viewFFExportFCL("0", "1", "1"); // Call getData whenever the route changes
      },
    },
     // Watch for AllResubmissionJOBNO changes to restart marquee when available
     AllResubmissionJOBNO: {
      handler(newVal) {
        if (newVal && this.$route.path === '/viewBillingDetails/viewBillingDetails') {
          this.$nextTick(() => {
            if (this.$refs.marquee) {
              this.restartMarquee();
            }
          });
        }
      },
      immediate: false
    },
  },
  methods: {
     proceedAssignmentProforma(
      all_module_id,

      isConsolidation,
      mainSalesSeries
    ) {
      // newContainerFlow,
      this.$sessionsStorage.set("editSalesExId", all_module_id);
      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          path: "/consolidation/viewBillingDetails/" + all_module_id,
          query: { mainSalesSeries: mainSalesSeries },
        });
      } else {
        this.$router.push({
          path: "/common/assignmentPerforma/" + all_module_id,
        });
      }
    },
    // resetModal() {
    //       this.name = ''
    //       this.nameState = null
    //     },
    wordWrap,
    PrintNote(ffExportFclSeries, uploadCreditDebit) {
      if (!ffExportFclSeries || !uploadCreditDebit) return;
      let key =
        "ASSIGNMENT_UPLOADS/" +
        ffExportFclSeries.replaceAll("/", "_") +
        "/" +
        uploadCreditDebit;
      this.openSignedDocument(key);
    },
    validateKnownLossJobModal(allModuleId, jobType,item){
      this.knownLossJobItem={
        remark:'',
        allModuleId:allModuleId,
      };
      console.log('item=>',item);
      this.$refs.KnownLossJobModal.show();
    },
    
    closeKnownLossJobModal() {
      this.knownLossJobItem={
        remark:'',
        allModuleId:'',
      };
      this.$refs.KnownLossJobModal.hide();
    },
    validateKnownLossJob(){
      let payload = {};
      if(this.knownLossJobItem.remark && this.knownLossJobItem.allModuleId){
      payload = {
          excelId: "validateKnownLossJob",
          allModuleId: this.knownLossJobItem.allModuleId,
          remark: this.knownLossJobItem.remark,
      };
      console.log('knownLossJobItem payload=>',payload)
      MasterService.ConsoleBooking(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          // console.log();
          if (status == 200 && data.CBFLAG == 1) {
            this.closeKnownLossJobModal();
            this.viewFFExportFCL("0", "1", "1");
          }
          this.alert.content = data.CBMSG;
          this.$refs["addPop"].open();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on validateKnownLossJob Error: ", error);
        });
      }
    },
    validateBilling(id, jobType) {
      this.selectedAllModuleId = id;
      this.isLoading = true;
      let payload = {
        allModuleId: id,
        job: jobType,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/validateCloseBilling.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.incompleteJobBill.length > 0) {
              this.incompleteJobBill = data.incompleteJobBill.toString();
              this.$refs["modal-close-conf"].show();
            } else {
              // alert("Hello");
              this.closeBill(id);
            }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    closeModalConfirm() {
      (this.incompleteJobBill = ""), this.$refs["modal-close-conf"].hide();
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    getBuyingSellingJobsList(type) {
      this.ContainerList = [];
      let payload = {};
      this.ExcelBSJBtnName = "Downloading .....";
      payload = {
        itemCode: "getBuyingSellingJobsList",
        type: type,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.getBuyingSellingJobsListFLAG == 1) {
            if (type == "Excell") {
              this.ExcelBSJBtnName = "FF EXP OF REPORT";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
            }
          }
        })
        .catch((error) => {
          console.log("Catch on getBuyingSellingJobsList Error: ", error);
        });
    },
    getReports(id, btnName) {
      let excelIdGivin = "";
      if (id == "BILLING_SCREEN") {
        excelIdGivin = "BILLING_SCREEN";
      } else if (id == "BILLING_SCREEN_ALL") {
        excelIdGivin = "BILLING_SCREEN_ALL";
      } else if (id == "MultiBILLING_SCREEN") {
        excelIdGivin = "MultiBILLING_SCREEN";
      } else if (id == "PENDING_REVERSE_BILLING") {
        excelIdGivin = "PENDING_REVERSE_BILLING";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        vessleFilter:this.vessleFilter,
        cnDNNoFilter: this.cnDNNoFilter,

        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        containerTypeFilter: this.containerTypeFilter,
        shippingLineFilter: this.shippingLineFilter,

        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: this.statusFilter,
        branchfilter: this.branchfilter,
        SOBFilter: this.SOBFilter,
        BillingFilter: this.BillingFilter,
        BillingTypeFilter: this.BillingTypeFilter,
        SlinePaymentFilter: this.SlinePaymentFilter,
        jobRecFilter: this.jobRecFilter,
        searchVal: this.filter,

        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        dateFilterType: this.dateFilterType,
      };
      if (id == "BILLING_SCREEN") {
        this.ExcelBtnName = "Downloading Please Wait .....";
      } else if (id == "BILLING_SCREEN_ALL") {
        this.ExcelExecutionBtnName = "Downloading Please Wait .....";
      } else if (id == "MultiBILLING_SCREEN") {
        this.ExcelMultiBillBtnName = "Downloading Please Wait .....";
      }

      CommonService.getAllPendingReverseTallyList(view_Assignment)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.excelName) {
              if (id == "BILLING_SCREEN") {
                this.ExcelBtnName = btnName;
              } else if (id == "BILLING_SCREEN_ALL") {
                this.ExcelExecutionBtnName = btnName;
              } else if (id == "MultiBILLING_SCREEN") {
                this.ExcelMultiBillBtnName = btnName;
              }

              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              //`http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` + data.excelName;
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on All_BL_List Error: ", error);
        });
    },
    // getReports(id) {
    //   this.isLoading=true
    //   let excelIdGivin = "";
    //   if (id == "BILLING_SCREEN") {
    //     excelIdGivin = "BILLING_SCREEN";
    //   }else if(id=="BILLING_SCREEN_ALL"){
    //     excelIdGivin = "BILLING_SCREEN_ALL";
    //   }else if(id=="MultiBILLING_SCREEN"){
    //     excelIdGivin = "MultiBILLING_SCREEN";
    //   }else if(id=="PENDING_REVERSE_BILLING"){
    //     excelIdGivin = "PENDING_REVERSE_BILLING";
    //   }
    //   let view_Assignment = {
    //     excelId: excelIdGivin,
    //     clientIdFilter: this.clientIdFilter,
    //     assignmentFilter: this.assignmentFilter,
    //     ContainerFilter: this.ContainerFilter,
    //     shiperInvFilter: this.shiperInvFilter,
    //     InvoiceNoFilter: this.InvoiceNoFilter,
    //     cnDNNoFilter: this.cnDNNoFilter,

    //     PORfilter:this.PORfilter,
    //     PODfilter:this.PODfilter,
    //     containerTypeFilter:this.containerTypeFilter,
    //     shippingLineFilter:this.shippingLineFilter,

    //     SBFilter: this.SBFilter,
    //     jobTypeFilter: this.jobTypeFilter,
    //     statusFilter: this.statusFilter,
    //     branchfilter: this.branchfilter,
    //     SOBFilter:this.SOBFilter,
    //     BillingFilter:this.BillingFilter,
    //     SlinePaymentFilter:this.SlinePaymentFilter,
    //     jobRecFilter: this.jobRecFilter,
    //     searchVal: this.filter,

    //     assignmentNo: "assignmentNo",
    //     fromDate: this.dateSearch.fromDate,
    //     toDate: this.dateSearch.toDate,
    //     dateRange: this.dateRange,
    //   };
    //   console.log(view_Assignment);
    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
    //     data: JSON.stringify(view_Assignment),
    //     crossDomain: true,

    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId"),
    //     },
    //   };

    //   axios(options)
    //     .then((result) => {
    //       const { statusText, status, data } = result;
    //       if ( status == 200 && data) {
    //         if (data.excelName != undefined) {
    //           window.location.href =
    //           // `http://164.52.198.182/pridaldev-phase2/Pridel_Reports/` +
    //             `https://uploadsp.pridel.com/Pridel_Reports/` +
    //             data.excelName;

    //           //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

    //           // console.log(abc)
    //         }
    //       this.isLoading=false
    //       }
    //     })
    //     .catch((error) => {});
    // },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.mainSalesSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    closeBill(id) {
      // alert(id)
      this.selectedAllModuleId = id;
      this.incompleteJobBill = "addPopClose";

      this.alert.content = "Are you sure to close Assignment Billing ?";
      this.$refs["addPopClose1"].open();
    },
    closeBillOk(type) {
      // alert(type);return false;
      // alert(this.incompleteJobBill);
      if (type == "cancel") {
        this.incompleteJobBill = "";
      } else if (type == "ok") {
        this.incompleteJobBill = "InVoices Done";
      }
      if (this.incompleteJobBill == "InVoices Done") {
        this.closingReason = "Direct Close InVoices Done";
      }
      if (this.closingReason) {
        this.isLoading = true;
        let payload = {
          allModuleId: this.selectedAllModuleId,
          closingReason: this.closingReason,
          path: this.$route.path, 
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TallyBilling/closeBillingStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
            this.closingReason="";
            (this.incompleteJobBill = ""), this.$refs["modal-close-conf"].hide();
            this.viewFFExportFCL("0", "1", "1");
          })
          .catch((error) => {});
      }
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL(CURRENT, "2", event);
    },
    proceedToManualInv() {
      this.$router.push({
        // path: "/allModuleForm/billing"
        path: "/allModuleForm/manualBill",
      });
    },
    filterSearch() {
      this.reload = false;
      this.viewFFExportFCL("0", "1", "1");
    },
    clearFilter() {
      this.clientIdFilter = "";
      this.jobTypeFilter = "";
      this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
      this.branchfilter = "";
      this.jobRecFilter = [];
      this.assignmentFilter = "";
      this.ContainerFilter = "";
      this.shiperInvFilter = "";
      this.InvoiceNoFilter = "";
      this.vessleFilter = "";
      this.cnDNNoFilter = "";
      this.PORfilter = "";
      this.PODfilter = "";
      this.containerTypeFilter = "";
      this.shippingLineFilter = "";
      this.SBFilter = "";
      this.SOBFilter = "3";
      this.BillingFilter = "3";
      this.BillingTypeFilter = "3";
      this.SlinePaymentFilter = "All";
      this.statusFilter = this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":"0";
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
      this.dateSearch = {
        startDate: "",
        endDate: "",
      };
      this.dateRange.startDate = "";
      this.dateRange.endDate = "";
      this.viewFFExportFCL("0", "1", "1");
    },
    proceedBilling(item, id, isConsolidation, mainSalesSeries) {
      this.$sessionsStorage.set("editSalesExId", item);
      // iewBillingDetails/consolidation
      if (isConsolidation == "1") {
        console.log("Consolidation");
        this.$router.push({
          // path: "/allModuleForm/billing"
          path: "/consolidation/viewBillingDetails/" + item,
          query: { mainSalesSeries: mainSalesSeries },
        });
      } else {
        if (id == "1") {
          this.$router.push({
            // path: "/allModuleForm/billing"
            path: "/allModuleForm/newTallyBillingMerge/" + item,
          });
        } else {
          this.$router.push({
            // path: "/allModuleForm/billing"
            // path: "/allModuleForm/billing/" + item,
            path: "/allModuleForm/newTallyBillingMerge/" + item,
          });
        }
      }
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    execActions(allModuleId, id, series) {
      this.mailallModuleId = allModuleId;
      this.eventId = id;
      this.mailExecSeries = series;

      if (id == "1") {
        this.alert.content = "Send Mail For Approval?";
        this.$refs["addPopMail"].open();
      }
      if (id == "2") {
        this.alert.content = "Are you sure you want to Approve?";
        this.$refs["addPopApprove"].open();
      }
      if (id == "3") {
        this.alert.content = "Are you sure you want to Reject?";
        this.$refs["addPopReject"].open();
      }
      if (id == "4") {
        this.alert.content = "Are you sure you want to delete this Execution ?";
        this.$refs["addPopDelete"].open();
      }
    },
    viewAllMultiBillingDetails() {
      this.$sessionsStorage.set("viewmultiBill_allModuleID", "");
      this.$sessionsStorage.set("viewmultiBill_billingSeries", "");
      this.$router.push({
        path: "/allModuleForm/viewAllMultiBillingDetails/",
      });
    },
    viewAllUnlockDetails() {
      this.$router.push({
        path: "/allModuleForm/UnlockPannelDetails/",
      });
    },
    viewMultiBillingDetails(allModuleID, multibillingSeries, Arr) {
      // alert(allModuleID);
      // alert(multibillingSeries);
      // console.log("Multi-Billing Arr=>",Arr);
      // return false;
      if (
        multibillingSeries != undefined &&
        multibillingSeries != null &&
        multibillingSeries != ""
      ) {
        this.$sessionsStorage.set("viewmultiBill_allModuleID", allModuleID);
        this.$sessionsStorage.set("viewmultiBill_billingSeries", multibillingSeries);
        this.$router.push({
          path: "/allModuleForm/viewMultiBillingDetails/",
        });
      }
    },
    onCloseAction(type) {
      if (type != "cancel") {
        this.isLoading = true;
        let payload = {
          allModuleId: this.mailallModuleId,
          salesExecutionNo: this.mailExecSeries,
          eventId: this.eventId,
        };
        console.log(payload);

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/salesDeleteActions.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },
    // goToMain() {
    //   this.$sessionsStorage.set("editallModuleId", "");
    //   this.$router.push({
    //     path: "/allModuleForm/allModuleForm"
    //   });
    // },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportFCLConPage(AM) {
      this.$sessionsStorage.set("editSalesExId", AM);

      this.$router.push({
        path: "/mainEnquiry/salesExecutionAll",
      });
    },
    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      console.log('this.$route.path=>',this.$route.path == '/viewBillingDetails/viewBillingDetails')
      this.BillingActiveStatus = false;
      this.consoBooking = [];
      this.AllResubmissionJOBNO = "";
      this.isLoading = true;
      let payload = {
        clientIdFilter: this.clientIdFilter,
        assignmentFilter: this.assignmentFilter,
        ContainerFilter: this.ContainerFilter,
        shiperInvFilter: this.shiperInvFilter,
        InvoiceNoFilter: this.InvoiceNoFilter,
        vessleFilter:this.vessleFilter,
        cnDNNoFilter: this.cnDNNoFilter,
        PORfilter: this.PORfilter,
        PODfilter: this.PODfilter,
        containerTypeFilter: this.containerTypeFilter,
        shippingLineFilter: this.shippingLineFilter,
        SBFilter: this.SBFilter,
        jobTypeFilter: this.jobTypeFilter,
        statusFilter: this.$route.path === '/viewBillingDetails/viewClosedAgentExpensePending'?"4":this.statusFilter,
        branchfilter: this.branchfilter,
        jobRecFilter: this.jobRecFilter,
        searchVal: this.filter,
        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        assignmentNo: "assignmentNo",
        fromDate: this.dateSearch.fromDate,
        toDate: this.dateSearch.toDate,
        dateRange: this.dateRange,
        dateFilterType: this.dateFilterType,
        SOBFilter: this.SOBFilter,
        BillingFilter: this.BillingFilter,
        BillingTypeFilter: this.BillingTypeFilter,
        SlinePaymentFilter: this.SlinePaymentFilter,
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/viewAllBillingList_NewV3_test.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.AllResubmissionJOBNO) {
              this.AllResubmissionJOBNO = data.AllResubmissionJOBNO;
            } else {
              this.AllResubmissionJOBNO = [];
            }
            if (data.assignmentData.length > 0) {
              this.consoBooking = data.assignmentData;
            } else {
              this.consoBooking = [];
            }
            if (this.reload == true) {
              if (data.clientMaster.length > 0) {
                this.clientMaster = data.clientMaster;
              }
              if (data.BranchDetailsFinal.length > 0) {
                this.branchList = data.BranchDetailsFinal;
              }
              if (data.shippingLineList.length > 0) {
                this.shippingLineList = data.shippingLineList;
              }
              if (data.containerTypeList.length > 0) {
                this.containerTypeList = data.containerTypeList;
              }
              if (data.LocationDetailsFinal.length > 0) {
                this.finalAllPlaceDataPOR = data.LocationDetailsFinal;
                this.finalAllPlaceDataPOD = data.LocationDetailsFinal;
              }
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    //Added By Priyanshu SIngh Multi Select Start

    ProceedMultiBilling() {
      let AllModule_ids_arr = this.AllModule_ids;
      let AllClient_ids_arr = this.AllClient_ids;
      let mainSalesSeries_arr = [];
      let newContainerFlow_arr = [];
      let isConsolidation_arr = [];
      let finalBillingCompleted_arr = [];
      let clientflag = AllClient_ids_arr.filter((x) => AllClient_ids_arr[0] != x).length;

      if (clientflag >= 1) {
        this.alert.content = "Please Choose Only Same Client Details";
        this.$refs["addPop"].open();
        return false;
      }
      this.consoBooking.forEach((sbook) => {
        AllModule_ids_arr.forEach((allmoduleARR) => {
          if (allmoduleARR == sbook.allModuleId) {
            console.log("sbook.allModuleId=>", sbook.allModuleId);
            console.log("sbook=>", sbook);
            newContainerFlow_arr.push(sbook.newContainerFlow);
            isConsolidation_arr.push(sbook.isConsolidation);
            mainSalesSeries_arr.push(sbook.mainSalesSeries);
            finalBillingCompleted_arr.push(sbook.finalBillingCompleted);
          }
        });
      });
      let flag = isConsolidation_arr.filter((x) => isConsolidation_arr[0] != x).length;
      let finalBillingflag = finalBillingCompleted_arr.filter(
        (x) => finalBillingCompleted_arr[0] != x
      ).length;
      if (finalBillingflag >= 1) {
        this.alert.content = "Please Choose only that Assignment Billing is pending.";
        this.$refs["addPop"].open();
        return false;
      }
      if (flag >= 1) {
        this.alert.content = "Please Choose Either Consolidation Or Normal Assignment";
        this.$refs["addPop"].open();
        return false;
      }
      console.log("ProceedMultiBilling.AllModule_ids_arr=>", AllModule_ids_arr);
      console.log("ProceedMultiBilling.mainSalesSeries_arr=>", mainSalesSeries_arr);
      console.log("ProceedMultiBilling.newContainerFlow_arr=>", newContainerFlow_arr);
      console.log("ProceedMultiBilling.isConsolidation_arr=>", isConsolidation_arr);
      let ContainerFlow_flag = newContainerFlow_arr.filter(
        (x) => newContainerFlow_arr[0] != x
      ).length;
      if (ContainerFlow_flag >= 1) {
        this.alert.content = "Something went wrong Please Contact Support with Admin";
        this.$refs["addPop"].open();
        return false;
      }
      this.proceedMultiTallyBilling(
        AllModule_ids_arr,
        newContainerFlow_arr,
        isConsolidation_arr,
        mainSalesSeries_arr
      );
    },
    proceedMultiTallyBilling(
      AllModule_ids_arr,
      newContainerFlow_arr,
      isConsolidation_arr,
      mainSalesSeries_arr
    ) {
      this.$sessionsStorage.set("AllModule_ids_arr", AllModule_ids_arr);
      this.$sessionsStorage.set("mainSalesSeries_arr", mainSalesSeries_arr);
      this.$sessionsStorage.set("newContainerFlow_arr", newContainerFlow_arr);
      this.$sessionsStorage.set("isConsolidation_arr", isConsolidation_arr);
      let isconsflag = isConsolidation_arr.filter((x) => isConsolidation_arr[0] == x)
        .length;
      let consolidationTXT = "";
      let Cont_FlowTXT = "";
      isConsolidation_arr.forEach((consolidation) => {
        // alert(consolidation);
        if (consolidation == 0) {
          consolidationTXT = "Normal";
        } else if (consolidation == 1) {
          consolidationTXT = "Consolidation";
        }
      });
      newContainerFlow_arr.forEach((Cont_Flow) => {
        if (Cont_Flow == 0) {
          Cont_FlowTXT = "Old";
        } else if (Cont_Flow == 1) {
          Cont_FlowTXT = "New";
        }
      });

      // alert(consolidationTXT);
      // alert(Cont_FlowTXT);
      if (consolidationTXT == "Normal" || consolidationTXT == "Consolidation") {
        // alert("Hello")
        // alert("Hello"+consolidationTXT)
        console.log("consolidationTXT", consolidationTXT, this.$refs["addPop"]);
        this.alert.content = "You have Chosen " + consolidationTXT + " Assignment";
        this.$refs["addPopClose"].open();
        console.log("this.alert.content=>", this.alert.content);
        this.$forceUpdate();
        // this.$nextTick(() => {
        //   this.$refs["addPop"].open();
        // })
      }

      // iewBillingDetails/consolidation
    },
    closeconsolidationTXTOk(type) {
      let consolidationTXT = "";
      let Cont_FlowTXT = "";
      let isConsolidation_arr = [];
      let newContainerFlow_arr = [];
      // alert(this.$sessionsStorage.get("isConsolidation_arr"));
      // alert(this.$sessionsStorage.get("newContainerFlow_arr"));
      // alert(type);
      console.log(
        "isConsolidation_arr=>",
        this.$sessionsStorage.get("isConsolidation_arr")
      );
      if (this.$sessionsStorage.get("isConsolidation_arr") != null) {
        isConsolidation_arr = this.$sessionsStorage.get("isConsolidation_arr").split(",");
      }
      if (this.$sessionsStorage.get("newContainerFlow_arr") != null) {
        newContainerFlow_arr = this.$sessionsStorage
          .get("newContainerFlow_arr")
          .split(",");
      }
      let isconsflag = isConsolidation_arr.filter((x) => isConsolidation_arr[0] == x)
        .length;
      isConsolidation_arr.forEach((consolidation) => {
        // alert(consolidation);
        if (consolidation == 0) {
          consolidationTXT = "Normal";
        } else if (consolidation == 1) {
          consolidationTXT = "Consolidation";
        }
      });
      newContainerFlow_arr.forEach((Cont_Flow) => {
        if (Cont_Flow == 0) {
          Cont_FlowTXT = "Old";
        } else if (Cont_Flow == 1) {
          Cont_FlowTXT = "New";
        }
      });

      if (type == "ok") {
        if (isconsflag == isConsolidation_arr.length) {
          if (consolidationTXT == "Consolidation") {
            console.log("Consolidation");
            this.alert.content = "Sorry Consolidation Only Single Billing Allowed";
            this.$refs["addPop"].open();
            // this.$router.push({
            //   // path: "/allModuleForm/billing"
            //   path: "/consolidation/viewMultiBillingDetails/",
            //   query: { mainSalesSeries: {} }
            // });
          } else if (consolidationTXT == "Normal") {
            console.log("Normal");

            if (Cont_FlowTXT == "Old") {
              this.$router.push({
                path: "/allModuleForm/newTallyMultiBillingMerge/",
              });
            } else if (Cont_FlowTXT == "New") {
              this.$router.push({
                path: "/allModuleForm/newTallyMultiBillingMerge/",
              });
            }
          }
        } else {
          this.alert.content = "Please Choose Either Consolidation Or Normal Assignment";
          this.$refs["addPop"].open();
          return false;
        }
      }
    },
    SelectAll: function () {
      console.log("this.consoBooking=>", this.consoBooking);
      this.isCheckAll = !this.isCheckAll;
      this.AllModule_ids = [];
      this.AllClient_ids = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.consoBooking) {
          if (this.consoBooking[key].finalBillingCompleted != 1) {
            let single_data = "";
            // single_data = this.consoBooking[key].allModuleId+"@"+this.consoBooking[key].newContainerFlow+"@"+this.consoBooking[key].isConsolidation+"@"+this.consoBooking[key].mainSalesSeries
            // this.AllModule_ids.push(single_data);
            this.AllModule_ids.push(this.consoBooking[key].allModuleId);
            this.AllClient_ids.push(this.consoBooking[key].TPTClient);
          }
        }
        console.log("this.AllModule_ids=>", this.AllModule_ids);
        console.log("this.AllClient_ids=>", this.AllClient_ids);
      }
    },
    updateSelectAll: function (e, item) {
      console.log("ids", e);
      console.log("ids", item);
      if (this.AllModule_ids.length == this.consoBooking.length) {
        // alert(this.AllModule_ids.length);
        // v-bind:id="module.TPTClient"
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      // alert(item.allModuleId);
      // alert(item.TPTClient);
      //       var index = this.AllClient_ids.map(x => {
      //         console.log("XXX=>",x);
      //   return x;
      // }).indexOf(x);
      // this.AllClient_ids.splice(index, 1);

      const istrue = this.AllModule_ids.includes(item.allModuleId);
      if (istrue == true) {
        this.AllClient_ids.push(item.TPTClient);
      } else {
        // let index = this.AllClient_ids.findIndex(this.checkCLient(item.TPTClient));
        const index = this.AllClient_ids.indexOf(item.TPTClient);
        // alert(index);
        this.AllClient_ids.splice(index, 1);
        // this.AllClient_ids.pop(item.TPTClient);
      }

      console.log("this.AllModule_ids=>", this.AllModule_ids);
      console.log("this.AllClient_ids=>", this.AllClient_ids);
    },
    pagechangeData() {
      // alert("Hello")
      // console.log("PageId=>",this.PaginationCount);
      this.perPage = this.PaginationCount;
      this.reload = false;
      this.viewFFExportFCL("0", "1", "1");
      // itemNew.invType = items;
    },
    checkCLient(TPTClient) {
      // alert(TPTClient+"Cli");
      return TPTClient;
    },
    restartMarquee() {
      // Only proceed if the marquee element exists
      if (this.$refs.marquee) {
        const marquee = this.$refs.marquee;
        marquee.addEventListener("animationiteration", () => {
          marquee.style.animation = "none";
          setTimeout(() => {
            marquee.style.animation = "marquee 15s linear infinite";
          }, 0);
        });
      }
    },
    calculateMinDate() {
      const currentDate = new Date();
      // Set the minimum date to tomorrow
      currentDate.setDate(currentDate.getDate());
      return currentDate.toISOString().split("T")[0];
    },
    calculateMaxDate() {
      // Set the maximum date to a future date if needed
      const maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + 50); // Adjust the number of days as needed
      return maxDate.toISOString().split("T")[0];
    },
    SelectMultiUser(user_items, lastSelectItem) {
      this.user_items = user_items;
      console.log("user_items=>", this.user_items);

      this.configration.multiple_user_id = "";
      this.configration.userName = "";
      if (this.user_items) {
        this.user_items.forEach((item_val) => {
          if (this.configration.userName) {
            this.configration.userName = this.configration.userName + "," + item_val.text;
          } else {
            this.configration.userName = item_val.text;
          }

          if (this.configration.multiple_user_id) {
            this.configration.multiple_user_id =
              this.configration.multiple_user_id + "," + item_val.value;
          } else {
            this.configration.multiple_user_id = item_val.value;
          }
        });
        console.log("configration=>", this.configration);
      }
      this.configration.multiple_user_arr = this.user_items;
    },
    goRolloverCont() {
      this.$router.push({
        path: "/ctt/rollover-event",
      });
    },
    ActiveAccordion(ActiveStatus) {
      if (ActiveStatus == true) {
        this.BillingActiveStatus = false;
      } else if (ActiveStatus == false) {
        this.BillingActiveStatus = true;
      }
    },
    updateConfig() {
      let payload = {};
      let multiple_user_arr = [];
      this.BillingShowList = [];

      if (this.user_items) {
        this.configration.userName = "";
        this.configration.multiple_user_id = "";
        multiple_user_arr = [];
        this.user_items.forEach((item_val) => {
          let userObj = {};
          if (this.configration.userName) {
            this.configration.userName = this.configration.userName + "," + item_val.text;
          } else {
            this.configration.userName = item_val.text;
          }

          if (this.configration.multiple_user_id) {
            this.configration.multiple_user_id =
              this.configration.multiple_user_id + "," + item_val.value;
          } else {
            this.configration.multiple_user_id = item_val.value;
          }
          userObj = { text: item_val.text, value: item_val.value };
          multiple_user_arr.push(userObj);
        });
        if (multiple_user_arr.length > 0) {
          this.configration.multiple_user_arr = multiple_user_arr;
        }
      }
      console.log(" this.configration=>", this.configration);
      // return false;
      payload = {
        itemCode: "updateConfig",
        configration: this.configration,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.updateConfigFLAG == 1) {
            this.BillingShowList = data.BillingShowList;
            this.configration.config_id = data.Configurationrow.config_id;
            this.configration.config_bill_start_date =
              data.Configurationrow.config_bill_start_date;
            this.configration.config_billing_date =
              data.Configurationrow.config_billing_date;
            this.configration.config_bill_end_date =
              data.Configurationrow.config_bill_end_date;
            this.alert.content = data.updateConfigMSG;

            if (
              data.Configurationrow.multiple_user_arr != "" &&
              data.Configurationrow.multiple_user_arr != null
            ) {
              this.configration.multiple_user_arr =
                data.Configurationrow.multiple_user_arr;
              this.user_items = data.Configurationrow.multiple_user_arr;
              if (this.user_items) {
                this.user_items.forEach((item_val) => {
                  if (this.configration.userName) {
                    this.configration.userName =
                      this.configration.userName + "," + item_val.text;
                  } else {
                    this.configration.userName = item_val.text;
                  }

                  if (this.configration.multiple_user_id) {
                    this.configration.multiple_user_id =
                      this.configration.multiple_user_id + "," + item_val.value;
                  } else {
                    this.configration.multiple_user_id = item_val.value;
                  }
                });
                console.log("configration=>", this.configration);
              }
            } else {
              this.configration.multiple_user_arr = [];
              this.user_items = [];
            }

            console.log(
              "this.configration.multiple_user_arr=>",
              this.configration.multiple_user_arr
            );
            this.$refs["addPop"].open();
          }
        })
        .catch((error) => {
          console.log("Catch on updateConfig Error: ", error);
        });
    },

    getConfig() {
      let payload = {};
      this.BillingShowList = [];
      payload = {
        itemCode: "getConfig",
        configration: this.configration,
      };

      CommonService.getAllJobList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.getConfigFLAG == 1) {
            console.log("data.Configurationrow=>", data.Configurationrow);
            this.BillingShowList = data.BillingShowList;
            this.configration.config_id = data.Configurationrow.config_id;
            this.configration.config_bill_start_date =
              data.Configurationrow.config_bill_start_date;
            this.configration.config_billing_date =
              data.Configurationrow.config_billing_date;
            this.configration.config_bill_end_date =
              data.Configurationrow.config_bill_end_date;

            if (
              data.Configurationrow.multiple_user_arr != "" &&
              data.Configurationrow.multiple_user_arr != null
            ) {
              this.configration.multiple_user_arr =
                data.Configurationrow.multiple_user_arr;
              this.user_items = data.Configurationrow.multiple_user_arr;
              if (this.user_items) {
                this.user_items.forEach((item_val) => {
                  if (this.configration.userName) {
                    this.configration.userName =
                      this.configration.userName + "," + item_val.text;
                  } else {
                    this.configration.userName = item_val.text;
                  }

                  if (this.configration.multiple_user_id) {
                    this.configration.multiple_user_id =
                      this.configration.multiple_user_id + "," + item_val.value;
                  } else {
                    this.configration.multiple_user_id = item_val.value;
                  }
                });
                console.log("configration=>", this.configration);
              }
            } else {
              this.configration.multiple_user_arr = [];
              this.user_items = [];
            }

            console.log(
              "this.configration.multiple_user_arr=>",
              this.configration.multiple_user_arr
            );
          }
        })
        .catch((error) => {
          console.log("Catch on getConfig Error: ", error);
        });
    },

    getExportPayload() {
            return {
                type: "Excell",
                DCfilterId: "0",
                searchVal: this.filter,
                fromSearch: "1",
                currentPage: "0",
                perPage: this.perPage,
                Filter: this.filter,
                isAllNo: 1,
            };
        },

        onExportSuccess(response) {
            console.log('Export successful:', response);
            // Refresh the data after successful export
             this.viewFFExportFCL("0", "1", "1");
        },

        onExportError(error) {
            console.error('Export failed:', error);
            // Handle export error (show notification, etc.)
        },
    //Added By Priyanshu SIngh Multi Select End
  },
};
</script>
<style>
.custom-badge {
  font-size: 0.8rem; /* Adjust the font size as needed */
  padding: 5px 5px; /* Adjust the padding as needed */
}
.marquee-container {
  width: 100%;
  overflow: hidden;
}

.marquee {
  animation: marquee 15s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>



// WEBPACK FOOTER //
// viewBillingDetails.vue?5011f1e6